import { UpdatesStatsigStore } from './store'

export const UpdatesStatsig = {
  Store: UpdatesStatsigStore,
}
